export default () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.625 27L22.3196 22.3055H15.9486V27H17.625Z" fill="#E54B24" />
      <path d="M27.0282 9.69454H22.3196V22.3055L27.0282 17.5968V9.69454Z" fill="#E54B24" />
      <path d="M14.4032 5L9.70867 9.69454H16.0797V5H14.4032Z" fill="#E54B24" />
      <path d="M5 22.3055H9.70867V9.69454L5 14.4032V22.3055Z" fill="#E54B24" />
    </svg>
  );
};
